import { DecisionStatusEnum } from "../api.generated";
import { DecisionType } from "../models";

export function formatDecisionStatus(status: string) {
  switch (status.toUpperCase()) {
    case DecisionStatusEnum.DENIED:
      return "Declined";
    case DecisionStatusEnum.INFORMATION_REQUESTED:
      return "Information required";
    case DecisionStatusEnum.APPROVED:
      return "Approved";
    case DecisionStatusEnum.PENDING:
      return "Pending Approval";
    default:
      return status.charAt(0).toUpperCase() + status.substring(1).toLowerCase();
  }
}

export function decisionStylePicker(decision: string) {
  switch (decision) {
    case DecisionStatusEnum.DENIED:
      return "bg-red-100 text-black";
    case DecisionStatusEnum.INFORMATION_REQUESTED:
      return "bg-yellow-100 text-black";
    case DecisionStatusEnum.APPROVED:
      return "bg-lime-100 text-black";
    case DecisionStatusEnum.PENDING:
      return "bg-gray-300 text-black";
  }
}

export function formatDecisionActionMessage(decision: DecisionType) {
  if (!decision || !decision.decisionTime) {
    return "";
  }

  if (decision.decision == DecisionStatusEnum.PENDING) {
    return `Requested on ${formatDecisionTime(decision)}`;
  }
  const userName = decision.userDetails
    ? `${decision.userDetails.firstName} ${decision.userDetails.lastName}`
    : "";
  if (decision.decision == DecisionStatusEnum.APPROVED) {
    return `Approved${
      userName ? ` by ${userName}` : ""
    } on ${formatDecisionTime(decision)}`;
  }

  if (decision.decision == DecisionStatusEnum.DENIED) {
    return `Declined${
      userName ? ` by ${userName}` : ""
    } on ${formatDecisionTime(decision)}`;
  }

  if (decision.decision == DecisionStatusEnum.INFORMATION_REQUESTED) {
    return `${userName ? `${userName} ` : ""}on ${formatDecisionTime(
      decision
    )}`;
  }
  return "";
}

export function formatDecisionTime(decision: DecisionType) {
  if (!decision || !decision.decisionTime) {
    return "";
  }
  return new Date(decision.decisionTime)
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(",", ";");
}
